import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '@/_metronic/helpers'
import {
  OperationsQueryResponse,
  MissingCreditTrx
} from './_models'

const BASE_URL = '/p2c/users'

export const getOperations = (userId: ID, query: string): Promise<OperationsQueryResponse> => {
  return axios
    .get(`${BASE_URL}/${userId}/statement?${query}`)
    .then((d: AxiosResponse<OperationsQueryResponse>) => {
      return d.data
    })
}

export const getMissingCredits = (userId: ID): Promise<Array<MissingCreditTrx>> => {
  return axios
    .get(`${BASE_URL}/${userId}/missing-credits`)
    .then((d: AxiosResponse<Response<Array<MissingCreditTrx>>>) => {
      return d.data
    })
    .then((d: Response<Array<MissingCreditTrx>>) => {
      return d.data || []
    })
}

export const reconcileMissingCredits = (userId: ID, trxs: Array<MissingCreditTrx>): Promise<void> => {
  return axios.put(`${BASE_URL}/${userId}/missing-credits`, {
    trxs: trxs.map((t: MissingCreditTrx) => ({
      _id: t._id,
      credit: t.credit
    }))
  })
}

export const addExceptionalCredits = ( userId: ID, credits: number, remark: string): Promise<void> => {
  return axios.put(`${BASE_URL}/${userId}/add-exceptional-credits`, {
    credits,
    remark
  })
}
